import type { SVGProps } from 'react';

const SvgHealthAndWelness = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="Health &#38; Wellness">
      <g id="Group">
        <path
          id="Vector"
          d="M3.42944 9.63217C4.1031 9.63217 5.0429 9.43173 5.63293 9.86446L6.80237 10.7206C7.23709 11.0392 7.70765 10.9343 8.19282 10.8587C8.8313 10.7585 9.40274 11.3034 9.40274 12.0122C9.40274 12.206 8.02689 12.6991 7.82845 12.7927C7.63737 12.8831 7.42527 12.9196 7.21498 12.8983C7.0047 12.877 6.80421 12.7987 6.63511 12.6719L5.31568 11.7049"
          stroke="#ECAE06"
          strokeWidth={0.670686}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M9.40299 11.5768L12.1182 10.3224C12.3576 10.2396 12.6159 10.2279 12.8619 10.2885C13.1079 10.3492 13.3311 10.4796 13.5047 10.6642L13.9493 11.1294C14.1086 11.2954 14.0715 11.5755 13.8743 11.6896L8.66164 14.7167C8.50764 14.807 8.33672 14.8646 8.15951 14.8859C7.9823 14.9073 7.8026 14.8919 7.63157 14.8409L3.42969 13.5858M8.74062 8.25828C8.74062 8.25828 10.1344 6.77225 10.1344 4.93978C10.1344 3.1073 8.74062 1.62128 8.74062 1.62128C8.74062 1.62128 7.34685 3.1073 7.34685 4.93978C7.34685 6.77225 8.74062 8.25828 8.74062 8.25828ZM8.74062 8.25828C8.74062 8.25828 10.7762 8.21315 12.0591 6.90433C13.342 5.59485 13.3865 3.51747 13.3865 3.51747C13.3865 3.51747 12.5436 3.53605 11.6012 3.89843M8.74062 8.25828C8.74062 8.25828 6.70505 8.21315 5.42211 6.90433C4.13918 5.59485 4.09471 3.51747 4.09471 3.51747C4.09471 3.51747 4.93761 3.53605 5.88007 3.89843"
          stroke="#ECAE06"
          strokeWidth={0.670686}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);
export default SvgHealthAndWelness;
